export default "__VITE_ASSET__Bk0C1L78__"